/**
 * 동기화가 트리거된 이유 (호출부 식별·디버깅용).
 * 새 경로를 파이프라인에 붙일 때마다 여기에 상수 추가.
 */
export const SyncReason = Object.freeze({
  /** 직접 호출·레거시 (사유 미지정) */
  REFRESH_MODULE_DEFECT_LAYER: 'refreshModuleDefectLayer',
  SHOULD_REFRESH_MAP: 'shouldRefreshMap',
  DEFECT_FILTERS_WATCH: 'defectFiltersWatch',
  GET_SITE_WATCHER: 'getSiteWatcher',
  GET_REPORT_ID_WATCH: 'getReportIdWatch',
  LOAD_DEFECT_MARKERS: 'loadDefectMarkers',
  FETCH_DEFECTS_LIST: 'fetchDefectsList',
  /** explorer store — 트리에서 리포트 선택 후 Vuex 가 지도 갱신 플래그 설정 */
  STORE_EXPLORER_SELECT_TREE: 'storeExplorerSelectTree',
  /** defect store — 결함 생성·수정·삭제 후 지도 갱신 플래그 설정 */
  STORE_DEFECT_AFTER_CHANGE: 'storeDefectAfterChange',
  MODULE_LIST_OPEN: 'moduleListOpen',
  UNKNOWN: 'unknown'
});
